import PropTypes from 'prop-types'

export const MY_PROFILE_TYPE = {
  firstName: PropTypes.string.isRequired,
  profilePic: PropTypes.string.isRequired,
  age: PropTypes.number.isRequired,
  pictures: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string.isRequired
  })).isRequired
}

export const CRUSH_PROFILE_TYPE = {
  id: PropTypes.number.isRequired,
  firstName: PropTypes.string.isRequired,
  profilePic: PropTypes.string.isRequired,
  age: PropTypes.number.isRequired,
  distance: PropTypes.string,
  pictures: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string.isRequired
  })).isRequired
}



// WEBPACK FOOTER //
// ./src/type-defs.js